console.log("uploaed script pr");

document.addEventListener('DOMContentLoaded', function () {
  const fixSwiperCarousels = () => {
    console.log('Executing fix')
    const uninitializedSwipers = document.querySelectorAll('swiper-container[init="false"].swiper-initialized');
    uninitializedSwipers.forEach(container => {
      if (typeof container.initialize === 'function') {
        container.removeAttribute('init')
        container.setAttribute('init', 'true')
        container.initialize()
        console.log('Swiper reinitialized')
      }
    })

    const initializedSwipers = document.querySelectorAll('swiper-container.swiper-initialized')
    initializedSwipers.forEach(container => {
      if (container.swiper) {
        container.swiper.update()
        console.log('Swiper updated')
      }
    })
  }

  if (document.documentElement.lang === 'fr') {
    setTimeout(fixSwiperCarousels, 500)
    setTimeout(fixSwiperCarousels, 1500)
    setTimeout(fixSwiperCarousels, 3000)
  }

  let lastUrl = location.href
  const observer = new MutationObserver(() => {
    if (location.href !== lastUrl) {
      lastUrl = location.href
      if (document.documentElement.lang === 'fr') {
        setTimeout(fixSwiperCarousels, 500)
        setTimeout(fixSwiperCarousels, 1500)
      }
    }
  })
  observer.observe(document, {subtree: true, childList: true})
})
